export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/login_icon_back@3x.png";